/* HNM homepage v2 (hnm-home-* sections): video carousel + hero video (muted, plays in view, loads 200px early),
   carousel arrows, product gallery thumbnails. Quick add, hover images and the quote carousel come from
   hnm-collection.js; Add to cart forms are plain /cart/add forms handled by the theme's Nym Cart Drawer. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pre = null, play = null;
  function load(v) {
    if (v.dataset.src && !v.getAttribute('src')) { v.src = v.dataset.src; v.removeAttribute('data-src'); }
  }
  function setupVideos(root) {
    var els = (root || document).querySelectorAll('video[data-hnmh-play]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(load); return; }
    if (!pre) pre = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { load(e.target); pre.unobserve(e.target); } });
    }, { rootMargin: '200px' });
    if (!play) play = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.1) {
          if (reduce) return;
          load(v); v.muted = true;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) { v.pause(); }
      });
    }, { threshold: [0, 0.1, 0.5] });
    els.forEach(function (v) {
      if (v.dataset.hnmhReady) return; v.dataset.hnmhReady = '1';
      v.muted = true; v.setAttribute('muted', '');
      pre.observe(v); play.observe(v);
    });
  }
  function setupRails(root) {
    (root || document).querySelectorAll('[data-hnmh-rail]').forEach(function (r) {
      if (r.dataset.hnmhReady) return; r.dataset.hnmhReady = '1';
      var t = r.querySelector('.hnmh-rail__track'); if (!t) return;
      var btns = r.querySelectorAll('.hnmh-rail__arrow');
      function step() { var c = t.children[0]; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(t).columnGap) || 16) : 300; }
      function upd() {
        var max = t.scrollWidth - t.clientWidth - 2;
        btns.forEach(function (b) { b.disabled = Number(b.dataset.dir) < 0 ? t.scrollLeft <= 2 : t.scrollLeft >= max; });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: Number(b.dataset.dir) * step(), behavior: 'smooth' }); }); });
      t.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }
  function setupGalleries(root) {
    (root || document).querySelectorAll('[data-hnmh-gal]').forEach(function (g) {
      if (g.dataset.hnmhReady) return; g.dataset.hnmhReady = '1';
      var main = g.querySelector('.hnmh-gal__main'), th = g.querySelectorAll('.hnmh-gal__thumb');
      if (!main || !th.length) return;
      th.forEach(function (b) { b.addEventListener('click', function () { main.scrollTo({ left: Number(b.dataset.i) * main.clientWidth, behavior: 'smooth' }); }); });
      main.addEventListener('scroll', function () {
        var i = Math.round(main.scrollLeft / Math.max(1, main.clientWidth));
        th.forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
      }, { passive: true });
    });
  }
  function setupSlides(root) {
    (root || document).querySelectorAll('[data-hnmh-slides]').forEach(function (box) {
      if (box.dataset.hnmhReady) return; box.dataset.hnmhReady = '1';
      var slides = [].slice.call(box.querySelectorAll('.hnmh-slide')), dots = [].slice.call(box.querySelectorAll('.hnmh-dot'));
      var n = slides.length; if (!n) return;
      var desk = window.matchMedia('(min-width: 700px)');
      var ms = Math.max(2, Number(box.dataset.interval) || 4) * 1000;
      var cur = 0, timer = null, hover = false, focus = false;
      function loadImg(s) {
        var im = s && s.querySelector('img[data-src]'); if (!im || !desk.matches) return;
        if (im.dataset.srcset) im.srcset = im.dataset.srcset;
        im.src = im.dataset.src; im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
      }
      function loadAll() { slides.forEach(loadImg); }
      function show(i) {
        i = (i + n) % n; loadImg(slides[i]);
        slides.forEach(function (s, j) {
          var on = j === i; s.classList.toggle('is-active', on);
          if (on) { s.removeAttribute('inert'); s.removeAttribute('aria-hidden'); } else { s.setAttribute('inert', ''); s.setAttribute('aria-hidden', 'true'); }
        });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        cur = i; box.setAttribute('data-active', i);
      }
      function canRun() { return n > 1 && !reduce && desk.matches && !hover && !focus && !document.hidden; }
      // The interval is the time a slide sits fully visible: a slide that just started fading in also gets the
      // CSS fade time (read from .hnmh-slide's transition, 0.6s), so it is not cut short by the fade.
      function fadeMs() { var d = parseFloat(getComputedStyle(slides[cur]).transitionDuration); return d > 0 ? d * 1000 : 0; }
      function schedule(noFade) { clearTimeout(timer); timer = null; if (canRun()) timer = setTimeout(function () { show(cur + 1); schedule(); }, ms + (noFade === true ? 0 : fadeMs())); }
      box.addEventListener('mouseenter', function () { hover = true; schedule(); });
      box.addEventListener('mouseleave', function () { hover = false; schedule(); });
      box.addEventListener('focusin', function () { focus = true; schedule(); });
      box.addEventListener('focusout', function (e) { if (!box.contains(e.relatedTarget)) { focus = false; schedule(); } });
      document.addEventListener('visibilitychange', schedule);
      if (desk.addEventListener) desk.addEventListener('change', function () { loadAll(); schedule(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { show(Number(d.dataset.i)); schedule(); }); });
      if (document.readyState === 'complete') loadAll(); else window.addEventListener('load', loadAll, { once: true });
      show(0); schedule(true);
    });
  }
  // Press ticker: measure one logo group, add copies until the row covers the screen plus one group, then move
  // exactly one group width per loop (seamless) at data-speed px/s. Recomputed on resize. CSS does the animation.
  function setupTickers(root) {
    (root || document).querySelectorAll('[data-hnmh-ticker]').forEach(function (vp) {
      if (vp.dataset.hnmhReady) return; vp.dataset.hnmhReady = '1';
      var track = vp.querySelector('.hnmh-press__track'); if (!track) return;
      var first = track.querySelector('.hnmh-press__group'); if (!first) return;
      var speed = Math.max(5, Number(vp.dataset.speed) || 50);
      function fit() {
        var w = first.getBoundingClientRect().width; if (!w) return;
        var groups = track.querySelectorAll('.hnmh-press__group');
        var need = Math.ceil((vp.clientWidth + w) / w) + 1;
        for (var i = groups.length; i < need; i++) {
          var c = first.cloneNode(true); c.classList.add('is-copy'); c.setAttribute('aria-hidden', 'true');
          c.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
          c.querySelectorAll('img').forEach(function (im) { im.alt = ''; });
          track.appendChild(c);
        }
        track.style.setProperty('--shift', w + 'px');
        track.style.setProperty('--dur', (w / speed).toFixed(2) + 's');
      }
      fit();
      var imgs = first.querySelectorAll('img');
      imgs.forEach(function (im) { if (!im.complete) im.addEventListener('load', fit, { once: true }); });
      var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 150); });
    });
  }
  function init(root) { setupVideos(root); setupRails(root); setupGalleries(root); setupSlides(root); setupTickers(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
